module.exports = __webpack_public_path__ + "static/utaustin-825e83f1ceb30dae5d0ea239891b5790.png";